import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Smartphone, CheckCircle, Phone, Wrench } from "lucide-react";

const BUSINESS_PHONE_LINK = "tel:+33549057490";

const BRANDS = [
  { name: "Samsung Galaxy", models: "S25, S24, S23, A55, A35, Note, Z Flip, Z Fold, Tab", color: "from-blue-500 to-blue-700" },
  { name: "Huawei", models: "P60, P50, Mate, Nova, Y series, MatePad", color: "from-red-500 to-red-700" },
  { name: "Xiaomi", models: "14, 13, Redmi Note, Poco, Mi Pad, Black Shark", color: "from-orange-500 to-orange-700" },
  { name: "OnePlus", models: "12, 11, Nord, OnePlus Open", color: "from-rose-500 to-rose-700" },
  { name: "Google Pixel", models: "9, 8, 7, Pro, Fold, Tablet", color: "from-emerald-500 to-emerald-700" },
  { name: "Autres marques", models: "Honor, Oppo, Vivo, Realme, Nokia, Motorola, Sony Xperia", color: "from-purple-500 to-purple-700" },
];

export const OtherBrandsSection = () => (
  <section className="section-padding bg-slate-50">
    <div className="container-custom">
      <div className="text-center mb-12">
        <Badge className="bg-slate-800 text-white px-4 py-2 mb-4 hover:bg-slate-800">
          <Wrench className="w-4 h-4 mr-2" />
          Multi-Marques
        </Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Experts toutes marques</h2>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">
          Notre expertise ne se limite pas à Apple. Nous réparons également
          <strong> Samsung, Huawei, Xiaomi, OnePlus, Google Pixel</strong> et bien d&apos;autres.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {BRANDS.map((brand) => (
          <Card key={brand.name} className="overflow-hidden hover:shadow-xl transition-all duration-300 group border-0">
            <div className={`h-2 bg-gradient-to-r ${brand.color}`}></div>
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${brand.color} flex items-center justify-center flex-shrink-0 shadow-lg`}>
                  <Smartphone className="h-7 w-7 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-xl text-slate-900 mb-1">{brand.name}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{brand.models}</p>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between">
                <span className="text-sm text-slate-500">Réparation disponible</span>
                <CheckCircle className="h-5 w-5 text-green-500" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="mt-12 text-center">
        <p className="text-slate-600 mb-4">Votre marque n&apos;est pas listée ? Contactez-nous !</p>
        <a href={BUSINESS_PHONE_LINK}>
          <Button size="lg" variant="outline" className="gap-2 border-2">
            <Phone className="h-5 w-5" />
            05 49 05 74 90
          </Button>
        </a>
      </div>
    </div>
  </section>
);
